import styled from 'styled-components';

const FormButton = styled.div`
	.loading-beneficiario {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 270px;
		color: ${({ theme }) => theme.colorBtnLoadingBtnDisabledFormButton};
		border-radius: 15px;
		border: none;
		background-color: ${({ theme }) =>
			theme.backgroundBtnLoadingBtnDisabledFormButton};
		font-size: 15px;
		padding: 10px 25px;
		margin: 10px auto;
		font-weight: ${({ theme }) => theme.fontWeightFormButton};
		font-family: ${({ theme }) => theme.fontFamilyFormButton};
		span {
			margin: 0 0 0 10px;
			padding: 0;
		}
	}

	.button-assinante-mobile {
		margin-bottom: 31px !important;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		background: transparent;
		color: ${({ theme }) => theme.colorBtnAddSubscriberBtnBackFormButton};
		font-size: 16px;
		padding: 10px 5px;
		width: 270px;
		border: 1px solid ${({ theme }) => theme.borderBtnAddSubscriberFormButton};
		border-radius: 15px;
		margin: auto;
		strong {
			clear: both;
			margin: auto;
			font-weight: ${({ theme }) => theme.fontWeightFormButton};
			font-family: ${({ theme }) => theme.fontFamilyFormButton};
		}
		svg {
			float: left;
			margin-left: 10px;
			color: ${({ theme }) => theme.colorBtnAddSubscriberBtnBackFormButton};
		}
	}

	.btn-mobile {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding-bottom: 20px;
		margin-top: 20px;
	}

	.btn-forward {
		width: 270px;
		color: ${({ theme }) => theme.colorBtnFowardFormButton};
		border-radius: 15px;
		border: none;
		background-color: ${({ theme }) => theme.backgroundBtnFowardFormButton};
		font-size: 15px;
		padding: 10px 25px;
		margin-top: -10px;
		font-weight: ${({ theme }) => theme.fontWeightBtnFowardBtnBackFormButton};
		font-family: ${({ theme }) => theme.fontFamilyFormButton};
	}

	.btn-back {
		float: left;
		width: 60px;
		height: 20px;
		color: hsl(0, 0%, 55%);
		border: 0px solid ${({ theme }) => theme.borderBtnBackFormButton};
		font-size: 16px;
		margin-top: 30px;
		strong {
			clear: both;
			margin: auto;
			font-weight: ${({ theme }) => theme.fontWeightBtnFowardBtnBackFormButton};
			font-family: ${({ theme }) => theme.fontFamilyFormButton};
		}
		svg {
			margin-left: 0px;
			color: ${({ theme }) => theme.colorBtnAddSubscriberBtnBackFormButton};
		}
	}

	.isDisabled {
		background-color: ${({ theme }) =>
			theme.backgroundBtnLoadingBtnDisabledFormButton};
		color: ${({ theme }) => theme.colorBtnLoadingBtnDisabledFormButton};
		width: 270px;
		border-radius: 15px;
		border: none;
		font-size: 15px;
		padding: 10px 25px;
		font-weight: ${({ theme }) => theme.fontWeightFormButton};
		font-family: ${({ theme }) => theme.fontFamilyFormButton};
		margin-top: -10px;
	}

	.btn-goForward-gray {
		width: 270px;
		color: ${({ theme }) => theme.colorBtnAdvanceFormButton} !important;
		border-radius: 15px;
		border: none;
		background-color: ${({ theme }) =>
			theme.backgroundBtnAdvanceFormButton}!important;
		font-size: 15px;
		padding: 10px 25px;
		//margin: 10px auto;
		font-weight: 600;
		border: solid 1px ${({ theme }) => theme.borderBtnAdvanceFormButton} !important;
	}
	@media (max-width: 767px) {
		.button-assinante-mobile {
			margin: auto;
		}
	}
	@media (max-width: 992px) {
		.btn-forward {
			width: 100%;
		}
		.isDisabled {
			width: 100%;
		}
		.button-assinante-mobile {
			width: 100%;
		}
	}

	.btn-border-color-yes {
		background: white !important;
		border-radius: 15px;

		border: 3px solid ${({ theme }) => theme.colorBorderBtn} !important;
		margin-right: 10px;
		align-items: center;
		width: 90px !important;
		font-family: inherit;
		font-size: 20px !important;

		:hover {
			color: #23a455 !important;
			background-color: white !important;
			border-color: #23a455 !important;
		}
	}
	.btn-border-color-continue {
		background: white !important;
		border-radius: 15px;

		border: 3px solid ${({ theme }) => theme.colorBorderBtn} !important;
		margin-right: 10px;
		align-items: center;
		width: 145px !important;
		font-family: inherit;
		font-size: 20px !important;

		:hover {
			color: #23a455 !important;
			background-color: white !important;
			border-color: #23a455 !important;
		}
	}
	.btn-border-color-not {
		background: white !important;
		border-radius: 15px;

		border: 3px solid ${({ theme }) => theme.colorBorderBtn} !important;
		margin-left: 10px;
		align-items: center;
		width: 90px !important;
		font-family: inherit;
		font-size: 20px !important;

		:hover {
			color: #f74949 !important;
			background-color: white !important;
			border-color: #f74949 !important;
		}
	}
	.btn-border-color-ok {
		background: white !important;
		border-radius: 15px;
		font-size: 20px !important;
		border: 3px solid ${({ theme }) => theme.colorBorderBtn} !important;
		width: 90px !important;
		font-family: inherit;

		align-items: baseline;

		:hover {
			color: ${({ theme }) => theme.colorBorderBtn};
			svg {
				color: ${({ theme }) => theme.colorBorderBtn} !important;
			}
		}
	}
	.btn-border-color-ok-epay {
		padding: 10px 0 !important;
		background: ${({ theme }) => theme.colorBorderBtn} !important;
		border-radius: 15px;
		font-size: 16px !important;
		border: none;
		width: 220px !important;
		font-family: inherit;

		align-items: baseline;
		color: white;
		font-weight: 600;
	}

	.overlay-box--content-epay {
		text-align: center;
		font-size: 25px;
		font-family: inherit;
		p {
			padding-top: 10px;
			text-align: left;
			font-size: 18px;
			margin-bottom: 10px;
		}
		h2 {
			color: ${({ theme }) => theme.colorBorderBtn} !important;
			font-weight: 900;
			font-size: 21px;
			padding-bottom: 0;
		}
		svg {
			margin-left: 0 !important;
		}
	}
`;

export default FormButton;
